<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 16:12:28
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-08-09 17:10:23
-->
<!-- 核心优势 -->
<template>
    <div class="coreAdvantagesBox">
        <div class="coreAdvantages">
            <div class="coreAdvantages_title"></div>
            <div class="coreAdvantages_content">
                <div class="coreAdvantages_item">
                    <div class="item-img">
                        <img src="../../../assets/image/home/core_icon_01.png">
                    </div>
                    <div class="item_info">
                        <div class="info_title">数据互联互通</div>
                        <div class="info_content">允许不同的软件服务之间进行无缝的数据交换和通信，实现数据的共享和流动，从而提高工作效率和协作能力。</div>
                    </div>
                </div>
                <div class="coreAdvantages_item">
                    <div class="item-img">
                        <img src="../../../assets/image/home/core_icon_02.png">
                    </div>
                    <div class="item_info">
                        <div class="info_title">快速部署和易用性</div>
                        <div class="info_content">基于云计算技术，用户可以通过网络直接访问和使用应用，无需进行繁琐的安装和配置过程。</div>
                    </div>
                </div>
                <div class="coreAdvantages_item">
                    <div class="item-img">
                        <img src="../../../assets/image/home/core_icon_03.png">
                    </div>
                    <div class="item_info">
                        <div class="info_title">持续技术支持</div>
                        <div class="info_content">提供持续的技术支持和服务，以确保平台的稳定性、安全性和功能的持续性改进。</div>
                    </div>
                </div>
                <div class="coreAdvantages_item">
                    <div class="item-img">
                        <img src="../../../assets/image/home/core_icon_04.png">
                    </div>
                    <div class="item_info">
                        <div class="info_title">数据安全保障</div>
                        <div class="info_content">通过数据加密、访问控制、备份恢复等措施确保用户数据的安全性和合规性。</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false,
    }
  },
  methods: {},
  mounted() {},
  destroyed() {},
}
</script>
<style scoped lang="scss">
.coreAdvantagesBox {
  width: 100%;
  height: 531px;
  margin-top: 70px;
  background-color: #fff;

  .coreAdvantages {
    width: 1200px;
    margin: 0 auto;
    .coreAdvantages_title {
      width: 391px;
      height: 91px;
      margin: 71px auto 56px;
      background: url('../../../assets/image/home/coreadvantage_title.png');
      background-size: 100% 100%;
    }
    .coreAdvantages_content {
      display: flex;
      justify-content: space-between;
    }
    .coreAdvantages_item {
      width: 278px;
      height: 384px;
      background: linear-gradient(180deg, #fffdfd 7%, #ffffff 100%);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      opacity: 1;
      box-sizing: border-box;
      .item-img {
        width: 100px;
        height: 100px;
        margin: 51px 89px 0 89px;
      }
      .item_info {
        .info_title {
          font-weight: 700;
          line-height: 28px;
          color: #4a4a4a;
          font-size: 20px;
          margin-top: 40px;
        }
        .info_content {
          text-align: left;
          padding: 17px 30px 37px 31px;
          line-height: 28px;
          color: #767676;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>

